module.exports = __webpack_public_path__ + "static/media/icono_descarga.8f875ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/icono_descarga.png
// module id = 2484
// module chunks = 3